import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaAngleDown } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { IoCartOutline } from "react-icons/io5";
import { MdKeyboardArrowDown } from "react-icons/md";
import { IoCloseSharp } from "react-icons/io5";
import { TbShoppingCart } from "react-icons/tb";
import { VscAccount } from "react-icons/vsc";
import './NavaBar.css'
import { IoMdPerson } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import { FaLinkedin } from 'react-icons/fa';
import { FaMap } from 'react-icons/fa';
import { FaGlobe } from 'react-icons/fa';
import { MdLocationOn } from 'react-icons/md';
import { FaSearch, FaUserCircle, } from 'react-icons/fa';
const NavaBar = () => {
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen((prev) => !prev);
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("phoneNumber");
    localStorage.removeItem("role");
    alert("You have logged out successfully.");
    navigate("/login");
  };
  const handleNavigate = (selectedStyle) => {
    navigate('/products', { state: { selectedStyle } });

  };
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);

  const toggleSubmenu = () => {
    setIsSubmenuOpen((prev) => !prev);
  };
  return (
    <div>

      <header id="header" className="header-default" >
        <div className='topheader_navabar'>
         
                <div style={{display:"flex",alignItems:"center"}}>
                   <img src="./phoneicons.png" alt="phoneicon" className='topheader'/>
                   <h6 className='topheader_heading'><a href="tel:+919620072626" className='topheader_heading'>+91 9620072626</a></h6>
                </div>
                <div style={{display:"flex",alignItems:"center",justifyContent:"center",flexGrow:"1"}}>
                   <h6 className='topheader_heading responive_topheader_heading'><a href='https://maps.app.goo.gl/1nWRpbK1Sz1DmVaE9' target='_black' style={{color:"white"}}>Get Direction To Store</a></h6>
                </div>
         
        </div>
        
        <div className="px_15 lg-px_60">
          <div className="row wrapper-header align-items-center">
            <div className="col-md-4 col-3 tf-lg-hidden">


              <a href="#mobileMenu" data-bs-toggle="offcanvas" aria-controls="offcanvasLeft" style={{color:"white"}}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16" fill="none">
                  <path d="M2.00056 2.28571H16.8577C17.1608 2.28571 17.4515 2.16531 17.6658 1.95098C17.8802 1.73665 18.0006 1.44596 18.0006 1.14286C18.0006 0.839753 17.8802 0.549063 17.6658 0.334735C17.4515 0.120408 17.1608 0 16.8577 0H2.00056C1.69745 0 1.40676 0.120408 1.19244 0.334735C0.978109 0.549063 0.857702 0.839753 0.857702 1.14286C0.857702 1.44596 0.978109 1.73665 1.19244 1.95098C1.40676 2.16531 1.69745 2.28571 2.00056 2.28571ZM0.857702 8C0.857702 7.6969 0.978109 7.40621 1.19244 7.19188C1.40676 6.97755 1.69745 6.85714 2.00056 6.85714H22.572C22.8751 6.85714 23.1658 6.97755 23.3801 7.19188C23.5944 7.40621 23.7148 7.6969 23.7148 8C23.7148 8.30311 23.5944 8.59379 23.3801 8.80812C23.1658 9.02245 22.8751 9.14286 22.572 9.14286H2.00056C1.69745 9.14286 1.40676 9.02245 1.19244 8.80812C0.978109 8.59379 0.857702 8.30311 0.857702 8ZM0.857702 14.8571C0.857702 14.554 0.978109 14.2633 1.19244 14.049C1.40676 13.8347 1.69745 13.7143 2.00056 13.7143H12.2863C12.5894 13.7143 12.8801 13.8347 13.0944 14.049C13.3087 14.2633 13.4291 14.554 13.4291 14.8571C13.4291 15.1602 13.3087 15.4509 13.0944 15.6653C12.8801 15.8796 12.5894 16 12.2863 16H2.00056C1.69745 16 1.40676 15.8796 1.19244 15.6653C0.978109 15.4509 0.857702 15.1602 0.857702 14.8571Z" fill="currentColor"></path>
                </svg>
              </a>

            </div>
            <div className="col-xl-4 tf-md-hidden">
              <nav className="box-navigation text-center">
                <ul className="box-nav-ul d-flex align-items-center gap-28">
                  <li className="menu-item">
                    <Link to="/" className="item-link" style={{ fontFamily: 'Sedan SC',color:"white" }}>Home</Link>

                  </li>

                  {/* Rent By Style */}
                  <li className="menu-item">
                    <a href="#" className="item-link" style={{ fontFamily: 'Sedan SC',color:"white" }}>
                      Rent By Categories <i className="icon icon-arrow-down"></i>
                    </a>
                    <div className="sub-menu mega-menu rentby">
                      <div className="container">
                        <div className="row">
                          <div className="col-lg-4 col1">
                            <div className="mega-menu-item">
                              <ul className="menu-list">
                                <li>
                                  <a
                                    onClick={() => handleNavigate('Jodhpuri Suits')}
                                    className="menu-link-text link"
                                    style={{ color: 'black', fontFamily: 'Sedan SC', cursor: 'pointer' }}
                                  >
                                    Jodhpuri Suits
                                  </a>
                                </li>
                                <li>
                                  <a
                                    onClick={() => handleNavigate('Suits & Tuxedos')}
                                    className="menu-link-text link"
                                    style={{ color: 'black', fontFamily: 'Sedan SC', cursor: 'pointer' }}
                                  >
                                    Suits & Tuxedos
                                  </a>
                                </li>
                                <li>
                                  <a
                                    onClick={() => handleNavigate('Blazers')}
                                    className="menu-link-text link"
                                    style={{ color: 'black', fontFamily: 'Sedan SC', cursor: 'pointer' }}
                                  >
                                    Blazers
                                  </a>
                                </li>
                                {/* <li>
                                  <a
                                    onClick={() => handleNavigate('Ethnic Jackets & Kurta Pyjama')}
                                    className="menu-link-text link"
                                    style={{ color: 'black', fontFamily: 'Sedan SC', cursor: 'pointer' }}
                                  >
                                    Ethnic Jackets & Kurta Pyjama
                                  </a>
                                </li> */}
                                <li>
                                  <a
                                    onClick={() => handleNavigate('Indowestern & Sherwani')}
                                    className="menu-link-text link"
                                    style={{ color: 'black', fontFamily: 'Sedan SC', cursor: 'pointer' }}
                                  >
                                    Indowestern & Sherwani
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="col-lg-4 col2">
                            <div className="collection-item hover-img">
                              <div className="collection-inner">
                                <a href="" className="collection-image img-style">
                                  <img className="lazyload" data-src="images/collections/DSC042291.jpg" src="images/collections/coll1.jpg" alt="collection-demo-1" />
                                </a>
                                <div className="collection-content">
                                  <a href="/products" className="tf-btn btn-xl collection-title fs-16 hover-icon"><span style={{ color: "black" }}>VIEW ALL</span><i className="icon icon-arrow1-top-left"></i></a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>

                  {/* Rent By Occasion */}
                  <li className="menu-item">
                    <a href="#" className="item-link" style={{ fontFamily: 'Sedan SC',color:"white" }}>
                      Rent By Occasion <i className="icon icon-arrow-down"></i>
                    </a>
                    <div className="sub-menu mega-menu rentby1">
                      <div className="container">
                        <div className="row">
                          <div className="col-lg-4 col1">
                            <div className="mega-menu-item">

                              <ul className="menu-list">
                                <li>
                                  <a
                                    onClick={() => handleNavigate('Graduation/Farewell')}
                                    className="menu-link-text link"
                                    style={{ color: 'black', fontFamily: 'Sedan SC', cursor: 'pointer' }}
                                  >
                                    Graduation/Farewell
                                  </a>
                                </li>
                                <li>
                                  <a
                                    onClick={() => handleNavigate('Office Event')}
                                    className="menu-link-text link"
                                    style={{ color: 'black', fontFamily: 'Sedan SC', cursor: 'pointer' }}
                                  >
                                    Office Event
                                  </a>
                                </li>
                                <li>
                                  <a
                                    onClick={() => handleNavigate('Party-Wear')}
                                    className="menu-link-text link"
                                    style={{ color: 'black', fontFamily: 'Sedan SC', cursor: 'pointer' }}
                                  >
                                    Party-Wear
                                  </a>
                                </li>
                                <li>
                                  <a
                                    onClick={() => handleNavigate('Ethnic Day')}
                                    className="menu-link-text link"
                                    style={{ color: 'black', fontFamily: 'Sedan SC', cursor: 'pointer' }}
                                  >
                                    Ethnic Day
                                  </a>
                                </li>
                                <li>
                                  <a
                                    onClick={() => handleNavigate('PreWedding Photoshoot')}
                                    className="menu-link-text link"
                                    style={{ color: 'black', fontFamily: 'Sedan SC', cursor: 'pointer' }}
                                  >
                                    PreWedding Photoshoot
                                  </a>
                                </li>
                                <li>
                                  <a
                                    onClick={() => handleNavigate('Attending Wedding')}
                                    className="menu-link-text link"
                                    style={{ color: 'black', fontFamily: 'Sedan SC', cursor: 'pointer' }}
                                  >
                                    Attending Wedding
                                  </a>
                                </li>
                                <li>
                                  <a
                                    className="menu-link-text link"
                                    style={{ color: 'black', fontFamily: 'Sedan SC', cursor: 'pointer' }}
                                  >
                                    Weddings
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="col-lg-4 col2">
                            <div className="collection-item hover-img">
                              <div className="collection-inner">
                                <a href="" className="collection-image img-style">
                                  <img className="lazyload" data-src="images/collections/DSC042291.jpg" src="images/collections/ss14.jpg" alt="collection-demo-1" />
                                </a>
                                <div className="collection-content">
                                  <a href="/products" className="tf-btn btn-xl collection-title fs-16 hover-icon"><span style={{ color: "black" }}>VIEW ALL</span><i className="icon icon-arrow1-top-left"></i></a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>


                  <li className="menu-item">
                    <a className="item-link" style={{ fontFamily: 'Sedan SC',color:"white" }} onClick={() => handleNavigate('Accessories')}>

                      Accessories
                    </a>

                  </li>





                </ul>
              </nav>
            </div>
            <div className="col-xl-4 col-md-4 col-6 text-center " >
              <a href="/" >
                <img src="./Royalhoodlogo2.png" alt="logo" className='navlogo' />
              </a>
            </div>
            <div className="col-xl-4 tf-md-hidden">
              <nav className="box-navigation text-center d-flex" style={{ justifyContent: "end" }}>
                <ul className="box-nav-ul d-flex justify-content-end align-items-center gap-10">
                  <li className="menu-item" >
                    <a href="/rentalprocess" className="item-link" style={{ fontFamily: 'Sedan SC',color:"white" }}>How It Works
                    </a>

                  </li>
                  <li className="menu-item">
                    <Link to="/Galley" className="item-link" style={{ fontFamily: 'Sedan SC',color:"white" }}>RH Gallery</Link>
                  </li>


                  <li className="menu-item" style={{ display: "flex" }}>

                    <Link to="https://maps.app.goo.gl/1nWRpbK1Sz1DmVaE9" target="_blank" className="item-link" style={{ fontFamily: 'Sedan SC',color:"white" }}><MdLocationOn style={{ fontSize: "20px", color: "white" }} />Store</Link>
                  </li>

                  {/* <li className="menu-item" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>

                    <Link to="https://www.linkedin.com/in/royalhood-in-0b1561346?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" className="item-link" style={{ fontFamily: 'Sedan SC' }}><FaLinkedin style={{ marginRight: "4px", fontSize: "17px", color: "white" }} /></Link>
                  </li>

                  <li className="menu-item" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Link to="https://www.instagram.com/royalhood.in?igsh=M2Rtd3V2dHl2dzBq" target="_blank" className="item-link" style={{ fontFamily: 'Sedan SC' }}><FaInstagram style={{ marginRight: "4px", fontSize: "17px", color: "white" }} /> Insta</Link>
                  </li> */}
                  
                  </ul>
                <ul className="box-nav-ul d-flex justify-content-end align-items-center gap-10" style={{ marginLeft: '20px' }}>
                  <li className="menu-item " style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Link to="/SearchBar" className="item-link" style={{ fontFamily: 'Sedan SC' }}><FaSearch style={{ marginRight: "4px", fontSize: "17px", color: "white" }} /></Link>
                  </li>
                  <li className="ser" style={{ fontFamily: 'Sedan SC' }}><Link to='/Cart' aria-controls="offcanvasLeft" className="nav-icon-item" style={{ fontWeight: "bold", fontFamily: 'Sedan SC' }}><TbShoppingCart style={{ fontSize: "21px",color:"white" }} /></Link></li>

                  {isLoggedIn ? (
                    <li style={{ position: 'relative' }}>
                      <a
                        href="#"
                        onClick={toggleSubmenu} // Toggle submenu on click
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          textDecoration: 'none',
                          fontFamily: 'Sedan SC',
                          cursor: 'pointer',
                          color:"white"
                        }}
                      >
                        <IoMdPerson size={24} />
                      </a>
                     

                      {isSubmenuOpen && ( // Show submenu only when isSubmenuOpen is true
                        <div
                          style={{
                            position: 'absolute',
                            top: '100%',
                            right: 0,
                            // left: "-100%",
                            background: 'white',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            borderRadius: '4px',
                            padding: '10px',
                            zIndex: 1000,
                          }}
                        >
                          <ul style={{ listStyleType: 'none', margin: 0, padding: 0 }}>
                            {role === 'admin' && (
                              <li style={{ marginBottom: '8px' }}>
                                <Link
                                  to="/dashboard"
                                  style={{
                                    color: 'black',
                                    textDecoration: 'none',
                                    fontFamily: 'Sedan SC',
                                  }}
                                >
                                  Admin
                                </Link>
                              </li>
                            )}
                            {role === 'user' && (
                              <li style={{ marginBottom: '8px' }}>
                                <Link
                                  to="/orders"
                                  style={{
                                    color: 'black',
                                    textDecoration: 'none',
                                    fontFamily: 'Sedan SC',
                                  }}
                                >
                                  User
                                </Link>
                              </li>
                            )}
                            <li>
                              <button
                                onClick={handleLogout}
                                style={{
                                  background: 'none',
                                  border: 'none',
                                  color: 'black',
                                  fontFamily: 'Sedan SC',
                                  cursor: 'pointer',
                                  textAlign: 'left',
                                }}
                              >
                                Logout
                              </button>
                            </li>
                          </ul>
                        </div>
                      )}
                    </li>
                  ) : (
                    <li
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        listStyleType: 'none',
                      }}
                    >
                      {/* <VscAccount
                        style={{ marginRight: '4px', fontSize: '17px', color: 'white' }}
                      /> */}
                      <Link
                        to="/login"
                        style={{
                          textDecoration: 'none',
                          color: 'white',
                          fontFamily: 'Sedan SC',
                        }}
                        className='login_button'
                      >
                        Login
                      </Link>
                    </li>
                  )}

                </ul>
              </nav>
            </div>

          </div>
        </div>
    
      </header>



      <div className="offcanvas offcanvas-start canvas-mb" id="mobileMenu">

        <span className="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"><IoCloseSharp size={24} /></span>
        <div className="mb-canvas-content">
          <div className="mb-body">
            <ul className="nav-ul-mb" id="wrapper-menu-navigation">
              <li className="nav-mb-item" data-bs-dismiss="offcanvas">
                <a href="/" className="mb-menu-link" style={{ fontFamily: 'Sedan SC', color: "black" }}>Home</a>
              </li>
              <li className="nav-mb-item">
                <a href="#dropdown-menu-one" className="collapsed mb-menu-link current" data-bs-toggle="collapse" aria-expanded="true" aria-controls="dropdown-menu-one">
                  <span style={{ fontFamily: 'Sedan SC', color: "black" }}>Rent By Categories</span>
                  <span className="btn-open-sub"></span>
                </a>
                <div id="dropdown-menu-one" className="collapse">
                  <ul className="sub-nav-menu" >
                    <li data-bs-dismiss="offcanvas"><a data-bs-dismiss="offcanvas" aria-label="Close" onClick={() => handleNavigate('Jodhpuri Suits')} className="sub-nav-link" style={{ fontFamily: 'Sedan SC', color: "black" }}>Jodhpuri Suits</a></li>
                    <li data-bs-dismiss="offcanvas"><a onClick={() => handleNavigate('Suits & Tuxedos')} className="sub-nav-link" style={{ fontFamily: 'Sedan SC', color: "black" }}>Suits & Tuxedos</a></li>
                    <li data-bs-dismiss="offcanvas"><a onClick={() => handleNavigate('Blazers')} className="sub-nav-link" style={{ fontFamily: 'Sedan SC', color: "black" }}>Blazers</a></li>
                    {/* <li data-bs-dismiss="offcanvas"><a onClick={() => handleNavigate('Ethnic Jackets & Kurta Pyjama')} className="sub-nav-link" style={{ fontFamily: 'Sedan SC', color: "black" }}>Ethnic Jackets & Kurta Pyjama</a></li> */}
                    <li data-bs-dismiss="offcanvas"><a onClick={() => handleNavigate('Indowestern & Sherwani')} className="sub-nav-link" style={{ fontFamily: 'Sedan SC', color: "black" }}>Indowestern & Sherwani</a></li>
                    {/* <li><a onClick={() => handleNavigate('Attending Wedding')} className="sub-nav-link" style={{ fontFamily: 'Sedan SC', color: "black" }}>Attending Wedding</a></li> */}
                    {/* <li><a onClick={() => handleNavigate('Weddings')} className="sub-nav-link" style={{ fontFamily: 'Sedan SC', color: "black" }}>Weddings</a></li> */}
                  </ul>
                </div>

              </li>
              <li className="nav-mb-item" >
                <a href="#dropdown-menu-two" className="collapsed mb-menu-link current" data-bs-toggle="collapse" aria-expanded="true" aria-controls="dropdown-menu-two">
                  <span style={{ fontFamily: 'Sedan SC', color: "black" }}>Rent By Occasion</span>
                  <span className="btn-open-sub"></span>
                </a>
                <div id="dropdown-menu-two" className="collapse">
                  <ul className="sub-nav-menu" >
                    <li data-bs-dismiss="offcanvas"><a onClick={() => handleNavigate('Graduation/Farewell')} className="sub-nav-link" style={{ fontFamily: 'Sedan SC', color: "black" }}>Graduation/Farewell</a></li>
                    <li data-bs-dismiss="offcanvas"><a onClick={() => handleNavigate('Office Event')} className="sub-nav-link" style={{ fontFamily: 'Sedan SC', color: "black" }}>Office Event</a></li>
                    <li data-bs-dismiss="offcanvas"><a onClick={() => handleNavigate('Party-Wear')} className="sub-nav-link" style={{ fontFamily: 'Sedan SC', color: "black" }}>Party-Wear</a></li>
                    <li data-bs-dismiss="offcanvas"><a onClick={() => handleNavigate('Ethnic Day')} className="sub-nav-link" style={{ fontFamily: 'Sedan SC', color: "black" }}>Ethnic Day</a></li>
                    <li data-bs-dismiss="offcanvas"><a onClick={() => handleNavigate('PreWedding Photoshoot')} className="sub-nav-link" style={{ fontFamily: 'Sedan SC', color: "black" }}>PreWedding Photoshoot</a></li>
                    <li data-bs-dismiss="offcanvas"><a onClick={() => handleNavigate('Attending Wedding')} className="sub-nav-link" style={{ fontFamily: 'Sedan SC', color: "black" }}>Attending Wedding</a></li>
                    <li data-bs-dismiss="offcanvas"><a onClick={() => handleNavigate('Weddings')} className="sub-nav-link" style={{ fontFamily: 'Sedan SC', color: "black" }}>Weddings</a></li>
                  </ul>
                </div>

              </li>

              <li className="nav-mb-item" data-bs-dismiss="offcanvas">
                <Link to="/products" className="mb-menu-link" style={{ fontFamily: 'Sedan SC', color: "black" }}>Accessories</Link>
              </li>

              <li className="nav-mb-item" data-bs-dismiss="offcanvas">
                <Link to="/rentalprocess" className="mb-menu-link" style={{ fontFamily: 'Sedan SC', color: "black" }}>How It Works</Link>
              </li>
              <li className="nav-mb-item" data-bs-dismiss="offcanvas">
                <Link to="/Galley" className="mb-menu-link" style={{ fontFamily: 'Sedan SC', color: "black" }}>R H Gallery</Link>
              </li>

            </ul>
            <div className="mb-other-content">
              <div className="d-flex group-icon" data-bs-dismiss="offcanvas">
                <Link to="/cart" className="site-nav-icon"><IoCartOutline />Cart</Link>
                <Link to="/SearchBar" className="site-nav-icon"><FaSearch />Search</Link>
              </div>
              <a href="#dropdown-menu-three" style={{color:"black"}}className="collapsed mb-menu-link current" data-bs-toggle="collapse" aria-expanded="true" aria-controls="dropdown-menu-two">
                  <span style={{ fontFamily: 'Sedan SC', color: "black" }}>Store Location</span>
                  <FaAngleDown />
                </a>
              <div id="dropdown-menu-three" className="collapse">
              <ul className="sub-nav-menu" >
          
                <li>#29, 1st Floor, BTM 2nd stage, <br />Bannerghatta Main Road,<br />  Opposite to Gopalan mall, <br />Next Jayadeva Metro Station, Bangalore - 560076 </li>
                <li>Email: <b>support@royalhood.in</b></li>
                <li>Phone: <b>+91 9620072626</b></li>
              </ul>
              </div>
            </div>
          </div>
          <div className="mb-bottom">
            <Link className="">
              {isLoggedIn ? (
                <li data-bs-dismiss="offcanvas">

                  <div style={{ paddingLeft: '5', paddingTop: '0', paddingBottom: '0' }}>

                    <div className="mega-menu-item">
                      <ul className="menu-list d-flex gap-2">

                        {role === "admin" && (
                          <li className="profilebox" style={{ marginBottom: "8px" }} data-bs-dismiss="offcanvas">
                            <Link to="/dashboard" style={{ color: "black", textDecoration: "none" }}>
                              Admin
                            </Link>
                          </li>
                        )}
                        {role === "user" && (
                          <li className="profilebox" style={{ marginBottom: "8px" }} data-bs-dismiss="offcanvas">
                            <Link to="/orders" style={{ color: "black", textDecoration: "none" }}>
                              User
                            </Link>
                          </li>
                        )}
                        <li className="profilebox" style={{ marginBottom: "8px" }} data-bs-dismiss="offcanvas">
                          <Link
                            onClick={handleLogout}
                            style={{ color: "black", textDecoration: "none" }}
                          >
                            Logout
                          </Link>
                        </li>
                      </ul>

                    </div>

                  </div>

                </li>

              ) : (
                <li className="mobloginbutton" style={{ display: "flex", alignItems: "center" }} data-bs-dismiss="offcanvas">
                  <VscAccount style={{ color:"black" }} size={20}/>
                  <Link to="/login" className="item-link nav-icon-item" style={{ fontFamily: "Sedan SC", color: "black" }}>
                    Login
                  </Link>
                </li>
              )}</Link>

            <div className='socialiconsmobile'>
              <Link to="https://maps.app.goo.gl/1nWRpbK1Sz1DmVaE9" target="_blank" className="item-link" style={{ fontFamily: 'Sedan SC' }}><MdLocationOn style={{ fontSize: "28px", color: "black", marginRight: "4px" }} /></Link>
              <Link to="https://www.linkedin.com/in/royalhood-in-0b1561346?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" className="item-link" style={{ fontFamily: 'Sedan SC' }}><FaLinkedin style={{ fontSize: "28px", color: "black", marginRight: "4px" }} /></Link>
              <Link to="https://www.instagram.com/royalhood.in?igsh=M2Rtd3V2dHl2dzBq" target="_blank" className="item-link" style={{ fontFamily: 'Sedan SC' }}><FaInstagram style={{ fontSize: "28px", color: "black", marginRight: "4px" }} /></Link>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default NavaBar



